import create from 'zustand';
import { persist } from 'zustand/middleware';

export const useOpenDetailAs = create(
	persist(
		(set) => ({
			openDetailAs: 'page',
			setOpenDetailAs: (value) => set({ openDetailAs: value }),
		}),
		{ name: 'open-detail-as-store' }
	)
);
